// extracted by mini-css-extract-plugin
export default {"loaderWrap":"_1frgO1ZE"};